import { get } from 'lodash';
import React, { Component } from 'react';

class ImageStaticMap extends Component {
  render() {
    const appId = 'gGlPcS3B1loUJ3PMvfmK';
    const appCode = 'dstn-thTPqx70vo6ixclxA';
    const alt = this.props.alt || '';
    const number = this.props.number || get(this.props, 'address.number');
    const street = this.props.street || get(this.props, 'address.street1') || get(this.props, 'address.street');
    const city = this.props.city || get(this.props, 'address.city');
    // const state = this.props.state || get(this.props, 'address.state'); // Not used by HERE API
    const zipcode = this.props.zipcode || get(this.props, 'address.zipcode');
    const country = 'us';
    const latitude = this.props.latitude || get(this.props, 'address.latitude');
    const longitude = this.props.longitude || get(this.props, 'address.longitude');
    const zoom = this.props.zoom || 15;
    const width = this.props.width || '360';
    const height = this.props.height || '240';

    const baseUrl = `https://image.maps.api.here.com/mia/1.6/mapview?app_id=${appId}&app_code=${appCode}&f=0&t=12&z=${zoom}`;
    let locationParams = '';
    let otherOptions = `&w=${width}&h=${height}`;

    // Location Setting
    // - Address Based
    if (city != null) {
      locationParams = `${number != null ? `&n=${number}` : ''}${street != null ? `&s=${street}` : ''}${city != null ? `&ci=${city}` : ''}${zipcode != null ? `&zi=${zipcode}` : ''}${country != null ? `&co=${country}` : ''}`.toLowerCase().replace(/\s/gi,'+');
    }
    // - Coordinate Based
    if (latitude != null && longitude != null) {
      locationParams = `&lon=${longitude}&lat=${latitude}`;
    }

    // If we have accuracy, show dot
    if (number == null || street == null || city == null) {
      otherOptions = `${otherOptions}&nodot`;
    }

    // If we couldn't get a location, don't create an image
    return locationParams.length === 0 ? null : (
      <img
        alt={alt}
        src={baseUrl + locationParams + otherOptions}
      />
    );
  }
}

export default ImageStaticMap;
